import React from "react";
import { QuestionCard } from "../shared/QuestionCard";
import { QuizChoiceCard, ChoiceOption } from "../form/QuizChoiceCard";
import { BodyCondition, BODY_LABEL } from "@/helpers/enums";
import { quizAsset } from "../shared/quizAssets";

type Props = {
  dogName: string;
  value?: BodyCondition;
  onChange: (condition: BodyCondition) => void;
};

const OPTIONS: ChoiceOption[] = [
  {
    value: BodyCondition.UNDERWEIGHT,
    label: BODY_LABEL[BodyCondition.UNDERWEIGHT],
    sublabel: "Ribs easily visible",
    icon: quizAsset("icon-body-under"),
  },
  {
    value: BodyCondition.IDEAL,
    label: BODY_LABEL[BodyCondition.IDEAL],
    sublabel: "Ribs felt easily",
    icon: quizAsset("icon-body-ideal"),
  },
  {
    value: BodyCondition.OVERWEIGHT,
    label: BODY_LABEL[BodyCondition.OVERWEIGHT],
    sublabel: "Ribs hard to feel",
    icon: quizAsset("icon-body-over"),
  },
];

export function BodyConditionQuestion({ dogName, value, onChange }: Props) {
  return (
    <QuestionCard
      title={`What is ${dogName || "your dog"}'s body condition?`}
      field="bodyCondition"
    >
      <QuizChoiceCard
        options={OPTIONS}
        selected={value ?? ""}
        onSelect={(v) => onChange(v as BodyCondition)}
        size="sm"
      />
    </QuestionCard>
  );
}
